import axios from 'axios';
import globalTheme from 'Assets/js/components/globalTheme';
import jsonpAdapter from 'axios-jsonp';

const einstein = (() => {
  /**
   * Get Einstein recommendations.
   * Use JSONP to overcome CORS issue, see https://joernberkefeld.github.io/SFMC-Cookbook/einstein/recommendation/#einstein-web-recommendations
   *
   * @param {String} block
   * @param {Function} callback
   * @param {Function} failureCallback
   */
  const getRecommendations = (block, callback, failureCallback = undefined) => {
    const MID = globalTheme.ecrm_mid();

    const country = globalTheme.language();

    const language = () => {
      if (country) {
        return `?locale=${country}`;
      }
      return '';
    };

    const url = `https://${MID}.recs.igodigital.com/a/v2/${MID}/${block}/recommend.jsonp${language()}`;
    axios({
      url,
      adapter: jsonpAdapter
    })
      .then((response) => {
        const items = response.data[0] ?? null;
        if (items && !items.empty) {
          callback(response);
        } else {
          // eslint-disable-next-line no-console
          console.warn(
            `%cEinstein Recommendations for "${block}" are flagged as empty.`,
            'background: #ffff77;color: red'
          );
          if (typeof failureCallback === 'function') {
            failureCallback();
          }
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(`Einstein Recommendations for "${block}" failed.`, error);
        if (typeof failureCallback === 'function') {
          failureCallback();
        }
      });
  };

  return {
    getRecommendations
  };
})();

export default einstein;
